import styled from "styled-components";

import buildColor from "../../_static/ColorPalette";
import { generateTransition, cubic } from "../../_static/Transitions";
import { buildText } from "../../_atom/Text";

export const Container = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  min-height: ${(props) => (props.isEmpty ? "100px" : "40px")};
`;

export const ExpandAll = styled.div`
  display: flex;
  align-items: center;
`;

export const ExpandAllText = styled(
  buildText({ tag: "strong", uppercase: true, fontSize: 10 })
)`
  padding-right: 5px;
`;

export const IconContainer = styled.div`
  display: flex;
  will-change: transform;
  transition: ${generateTransition(cubic, "transform")};
  transform: rotate(${(props) => (props.isOpen ? "180deg" : "0deg")});
`;

export const Races = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;

  ul {
    padding-top: 0;
    padding-bottom: 0;
    border-top: 1px solid ${buildColor("blue", "100")};

    > li:first-child {
      border: none;
    }
  }
`;

export const RaceRow = styled.div`
  > div > div:last-child {
    border-bottom: 1px solid ${buildColor("blue", "100")};
  }
`;

export const ChangesNumberContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const RaceHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
  height: 40px;
`;

export const ChangesNumber = styled.strong`
  font-size: 10px;
  padding-left: 3px;
`;
